module.exports = __webpack_public_path__ + "img/phone.31c27f0e.svg";